import apiClient from "./axios-client";
/**
 * Get Prefilled Taxhead
 * @returns
 */
export const getPrefilledTaxhead = async () => {
  const response = await apiClient.get(`master/get-prefilled-taxhead`);
  return response.data;
};

/**
 * Generate Prefilled Receipt
 * @returns
 */
export const generatePrefilledReceipt = async (body) => {
  // {
  //     "propertyCode":"1070601156.00",
  //     "propertyName":"श्रीम.मायारामानी रामकली रिझुमल",
  //     "propertyAddress":"सी.ब्लॉक 4/10 अर्धा भाग,पिंपरी -17",
  //     "modeofPayment":"Cash",
  //     "receiptDate":"2024-07-21",
  //     "chequeddDate":"2024-07-21",
  //     "chequeDDNo":"",
  //     "bankName":"Test",
  //     "remark":"Test",
  //     "paidAmount":1000,
  //     "budgetHeadRequestDTO":[{
  //         "taxName":"करमणूक कर",
  //         "amount":1000
  //     }]
  // }
  const response = await apiClient.post(
    `receipt/generate-prefilled-receipt`,
    body
  );
  return response.data;
};

/**
 * Get Prefilled Taxhead
 * @returns
 */
export const getBasicPropertyDetails = async (propertyCode) => {
  const response = await apiClient.get(
    `property/getBasicPropertyDetails?propertyCode=${propertyCode}`
  );
  return response.data;
};
